/**
 * Extract the 11-char video id from any common YouTube URL form:
 * watch?v=, youtu.be/, /embed/, /shorts/, /live/, with or without extra params.
 * Returns null if no valid id is found.
 */
export function youtubeVideoId(url: string | null | undefined): string | null {
  if (!url || typeof url !== 'string') return null;
  const ID = /^[A-Za-z0-9_-]{11}$/;

  // Bare id passed directly.
  if (ID.test(url.trim())) return url.trim();

  let u: URL;
  try {
    u = new URL(url.trim());
  } catch {
    return null;
  }

  const host = u.hostname.replace(/^www\.|^m\./, '');

  // youtu.be/<id>
  if (host === 'youtu.be') {
    const id = u.pathname.slice(1).split('/')[0];
    return ID.test(id) ? id : null;
  }

  if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
    // watch?v=<id>
    const v = u.searchParams.get('v');
    if (v && ID.test(v)) return v;
    // /embed/<id>, /shorts/<id>, /live/<id>, /v/<id>
    const m = u.pathname.match(/\/(?:embed|shorts|live|v)\/([A-Za-z0-9_-]{11})/);
    if (m) return m[1];
  }

  return null;
}
